module.exports = __webpack_public_path__ + "media/images/dmc/tour-05-9da971d78a7c1e9a3c7351be4a347948.jpg";